module.exports = __webpack_public_path__ + "img/ml.1dd7a9cc.svg";